import {Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ClientService } from '../services/client.service';
import { ToastrService } from 'ngx-toastr';
import { SearchPackage } from '../../packages-module/models/searchPackage';
import { ScreeningService } from '../../screening-module/services/screening.service';
import { AlternateScoringModel, Client } from '../models/clientLocation';
import { DatePipe } from '@angular/common';
import { ScreeningLight } from '../../models/screeningInvite';
import { UserService } from 'src/app/users-module/services/user.service';
import { FilteringService } from 'src/app/services/filtering.service';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { NgbModal, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import {AddPaymentGroupModalComponent} from '../../shared-components-module/payments/add-payment-group-modal/add-payment-group-modal.component';
import { AddPaymentMethodModalComponent } from 'src/app/shared-components-module/payments/add-payment-method-modal/add-payment-method-modal.component';
import {PaymentsService} from '../../services/payments.service';
import {takeUntil, tap} from 'rxjs/operators';
import { Subject} from 'rxjs';
import { RiqAlertComponent } from 'src/app/shared-components-module/riq-alert/riq-alert.component';
import { ScoringModelMgrComponent } from '../scoring-model-mgr/scoring-model-mgr.component';

@Component({
  selector: 'app-client-view',
  templateUrl: './client-view.component.html',
  styleUrls: ['./client-view.component.less']
})
export class ClientViewComponent implements OnInit, OnDestroy {

  
  def: NgbNav;
  addingPackages : boolean = false;
  filtersApplied : boolean;
  showUsers : boolean = false;
  showPackages : boolean = false;
  showProperties : boolean = false;
  showScreenings : boolean = false;
  showIQSettings : boolean = false;
  showNotes : boolean = true;
  showClientInfo : boolean = false;
  showUploadUserPane : boolean = false;

  loadedModel: AlternateScoringModel;
  refreshSliderSub: EventEmitter<boolean> = new EventEmitter();

  private _unsubscribeAll = new Subject();
  public activeId: number = 1;

  clientId : number
  model : Client;
  error: boolean;
  constructor(
    public toastr : ToastrService,
    public datePipe: DatePipe,
    public screening : ScreeningService,
    public auth : AuthService,
    public location : Router,
    public activatedRoute: ActivatedRoute,
    public clients : ClientService,
    public toast : ToastrService,
    public properties : PropertyService,
    public packages : SearchPackageService,
    public filtering : FilteringService,
    private modalService : NgbModal,
    public users : UserService,
    public readonly paymentsService: PaymentsService
  ){

  }

  ngOnInit() {

    this.activatedRoute.paramMap.subscribe((p : ParamMap) => {
      this.clientId = parseInt(p.get('client'));

      this.clients.GetClientById(this.clientId).subscribe((rslt : Client) =>{
        this.clients.currentClient = rslt;
        this.model = Object.assign(new Client(),rslt );
      });


    });

    this.paymentsService.$displayPaymentModal.pipe(takeUntil(this._unsubscribeAll)).subscribe((r: boolean) => {
      if (r) {
        this.addPaymentMethod();
      }
    });

  }

  crimGridTabSelect(): void {
    console.log(true);
  }

  public ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  public editClient(){
    this.location.navigateByUrl(`clients/edit/${this.model.id}`);
  }

  public get currentDate() : string {
    var date = new Date();
    return this.datePipe.transform(date, 'MM-dd-yyyy')
  }
  
  public get saveAltModelTxt() : string {
    if(this.loadedModel.id > 0) return 'Update model';
    else return 'Save new model';
  }

  update(val : any){
    if (this.model[val.name] != val.value) {
      this.model[val.name] = val.value;
    }
    this.model[val.name] = val.value;
}

updateThresholds(){
  //RIQ-2207: pop a RIQ alert modal to warn user that this action applies to all underlying properties
  const modalRef = this.modalService.open(RiqAlertComponent, { centered: true, size: 'lg' });
  modalRef.componentInstance.name = 'ClientSliderUpdateModal';
  modalRef.componentInstance.title = "Are you sure you want to do this?";
  modalRef.componentInstance.confirmButtonText = "Yes I'm sure";
  modalRef.componentInstance.cancelButtonText = "Cancel";
  modalRef.componentInstance.alertBody = `Changing this setting at the client level will change scoring for ALL PROPERTIES belonging to ${this.model.clientName}. If you want to change a single property, please go to the Properties page. Are you sure you want to change ALL PROPERTIES of ${this.model.clientName}?`;
  // modalRef.componentInstance.shown.subscribe((ev: any)=>{
    modalRef.componentInstance.evnt.subscribe((ev:boolean)=>{
      this.model.threshholdsUpdated = true;
      this.clients.UpdateClientSingle(this.model).subscribe(
        (dta: boolean)=>{
          if(dta){
            this.toastr.success('Client updated successfully.', 'Update Succeeded!');
            modalRef.dismiss()
          }else{
            this.toastr.error('Client update failed.', 'Update Failed!', { disableTimeOut: true, closeButton: true});
          }
      },
      (err: any)=>{
        this.toastr.error('Client update failed.', 'Update Failed!', { disableTimeOut: true, closeButton: true});
      })
    });
}

  public searchesString(pkg: SearchPackage): string {
    let s: string = "";
    pkg.searches.forEach(srch => {
      if (s.length == 0) {
        s += srch.name
      } else {
        s += ", " + srch.name
      }
    });
    return s;
  }

  addPropertyToClient(){
    this.clients.inClientSetup = true;
    this.location.navigateByUrl(`/properties/new/${this.clientId}`);
  }

  newUser(){
    this.location.navigateByUrl(`/users/new/${this.clientId}`);
  }
  viewScreening(scrn : ScreeningLight, setEditState : boolean = false) {
    this.location.navigateByUrl(`screenings/review/${scrn.id}${setEditState ? "/Screening" : ""}`);
  }

  addPaymentMethod() : void {
    const modalRef = this.modalService.open(AddPaymentMethodModalComponent, { centered: true, size: 'lg' })
    modalRef.componentInstance.name = 'AddPaymentMethodModalComponent';
    modalRef.componentInstance.clientId = this.clientId;
  }

  public editPaymentGroup(): void {
    const modalRef = this.modalService.open(AddPaymentGroupModalComponent, {centered: true, size: 'lg'});
    modalRef.componentInstance.name = 'AddPaymentGroupModalComponent';
    modalRef.componentInstance.clientId = this.clientId;
  }

  

}
